import React, {FC} from "react";
import {Space} from "antd";
import ScoreInput from "./ScoreInput";
import {IMatch} from "../../Interfaces/IMatch";
import {Paragraph} from "../Typography";

interface Props {
    disable: boolean,
    match: IMatch,
}

const ShowResult: FC<Props> = (props: Props) => {

    const noop = (_value: any) => {};

    const scoreDom = props.match.Score_Dom;
    const scoreExt = props.match.Score_Ext;

    return (
        <Space direction={"vertical"} size={1}>
            <Paragraph style={{width: "100px", textAlign: "center"}}>Résultat</Paragraph>
        <Space>
            <ScoreInput score={scoreDom} disable={true} callback={noop}/>
            <ScoreInput score={scoreExt} disable={true} callback={noop}/>
        </Space>
        </Space>
    );
}
export default ShowResult;